import { useState } from "react";
import { Upload } from "lucide-react";
import { toast } from "sonner";
import { uploadImage } from "@/lib/api";

export default function ImageField({ label, value, onChange, testid }) {
  const [uploading, setUploading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setUploading(true);
    try {
      const url = await uploadImage(file);
      onChange(url);
      toast.success("Slika naložena");
    } catch {
      toast.error("Nalaganje slike ni uspelo");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div data-testid={`${testid}-field`}>
      {label && (
        <label className="text-xs font-tech uppercase tracking-wider text-stone-500 block mb-1.5">{label}</label>
      )}
      <div className="flex gap-2">
        <input
          data-testid={testid}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder="URL slike ali naloži datoteko →"
          className="flex-1 h-11 px-4 rounded-lg bg-white border border-[#E4E0D7] text-sm focus:outline-none focus:ring-2 focus:ring-[#2D4030]/30 min-w-0"
        />
        <label
          data-testid={`${testid}-upload-btn`}
          className={`shrink-0 h-11 px-4 rounded-lg bg-[#2D4030] text-[#FBF9F5] text-sm font-semibold flex items-center gap-2 cursor-pointer hover:bg-[#1E2C20] transition-colors ${uploading ? "opacity-60 pointer-events-none" : ""}`}
        >
          <Upload className="w-4 h-4" /> {uploading ? "Nalagam …" : "Naloži"}
          <input
            data-testid={`${testid}-file-input`}
            type="file"
            accept="image/jpeg,image/png,image/webp,image/gif"
            className="hidden"
            onChange={handleFile}
            disabled={uploading}
          />
        </label>
      </div>
      {value && (
        <img src={value} alt="predogled" className="mt-2 h-16 w-24 rounded-lg object-cover border border-[#E4E0D7]" />
      )}
    </div>
  );
}
